module.exports = __webpack_public_path__ + "assets/GTAmerica-ExtendedRegular.woff";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExtendedRegular.woff
// module id = 1012
// module chunks = 19